import { render } from "./ModalPDF.vue?vue&type=template&id=db5dcd64"
import script from "./ModalPDF.vue?vue&type=script&lang=js"
export * from "./ModalPDF.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Git-Local\\stfg.git\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__